import api from '../../common/services/api';
import consts from '../../config/constants';

const getScholarships = async (course_name, uf_state, city_name) => {

    const data = await api.get(`${consts.API_BASE_URL}/exam/bolsas`, {
        params: {
            course_name: course_name,
            uf_state: uf_state,
            city_name: city_name
        }
    })

    return data
}

export { getScholarships }